import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_651e6e5a-cd5c-447a-9803-ab87665e91c6/artifacts/e7h6cldm_WhatsApp%20Image%202026-07-04%20at%204.07.43%20PM.jpeg";

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Formats a YYYY-MM-DD (or ISO) date string to DD/MM/YY (e.g. 25/12/26). No time.
export function fmtDate(d) {
  if (!d) return "";
  const s = String(d);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}/${m[1].slice(2)}`;
  return s;
}

// Opens (or prints) a consignment's POD file. Fetches with auth cookie, then opens a blob URL.
export async function openPodFile(id, doPrint = false) {
  const res = await api.get(`/consignments/${id}/pod`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const type = res.data.type || "";
  if (!doPrint) { window.open(url, "_blank"); return; }
  const w = window.open("", "_blank");
  if (!w) { window.open(url, "_blank"); return; }
  const body = type.includes("pdf")
    ? `<iframe src="${url}" style="border:0;width:100%;height:100vh"></iframe>`
    : `<img src="${url}" style="max-width:100%;display:block;margin:0 auto"/>`;
  w.document.write(`<html><head><title>POD Print</title></head><body style="margin:0" onload="setTimeout(function(){window.focus();window.print();},600)">${body}</body></html>`);
  w.document.close();
}

export default api;
